define('view/module/review/ReviewListModuleItemView',['require','view/controller/review/ReviewItemView'],function (require) {

    var ReviewItemView = require('view/controller/review/ReviewItemView');

    /**
     * Reviews module item view
     *
     * @class ReviewListModuleItemView
     */
    return ReviewItemView.extend({

        template: '#reviews_list_module_item_view',

  /*      ui : {
            'likeBtn' : '#sb_client_review_item_like',
            'dislikeBtn' : '#sb_client_review_item_dislike',
        },

        triggers: {
            'click @ui.likeBtn': 'like_review',
            'click @ui.dislikeBtn': 'dislike_review',
        },

        opts : {},

        initialize: function(options) {
            if(_.isObject(options)){
                this.opts = options;
            }
        },

        serializeData: function () {
            var result = Marionette.CompositeView.prototype.serializeData.apply(this);
            result['is_logged_in'] = this.opts && this.opts['logged_in'];
            return result;
        },
        */
    });

});
